import { Component, numberAttribute } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-site-updates',
  templateUrl: './site-updates.component.html',
  styleUrls: ['./site-updates.component.scss']
})
export class SiteUpdatesComponent {
  internalUserCheckURL = '/api/users/is_internal_user.php';
  permissionToLoad: boolean = false;
  updatesText: SiteUpdateSection[] = [
    {
      date: new Date('2026-04-17'),
      updates: [
        {
          route: '/zone_manager',
          description: 'View freight rate zones here.',
          newRoute: true
        },
        {
          route: '/financials/:lading_uuid',
          description: 'Users can now mark customer charges as audited/approved/finalized here.',
          newRoute: false
        },
        {
          route:'/customer_financials_reports',
          description: 'Select TG ladings and generate a csv file of their charges here.',
          newRoute: true
        }
      ]
    },
    {
      date: new Date('2026-04-10'),
      updates: [
        {
          route: '/financials/:lading_uuid',
          description: 'The financials tab has been moved to its own page. Layout and functions have been updated.',
          newRoute: true
        },
        {
          route: '/carrier_orders',
          description: 'Dispatchers and users with the admin role can now use the carrier orders page and choose carriers to view their respective carrier orders tables.',
          newRoute: false
        }
      ]
    },
    {
      date: new Date('2026-04-09'),
      updates: [
        { 
          route: '/carrier_orders',
          description: 'New columns and UI added.',
          newRoute: false
        },
        {
          route: 'N/A',
          description: "Spencer's ASNs are now transferred into our database automatically.",
          newRoute: false
        },
        {
          route: 'N/A',
          description: "Carrier orders link has been added to the side menu for FBI, Ulaap, and CRST users.",
          newRoute: false
        },
        {
          route: '/work_order_details',
          description: "UI update added. Lading notes and statuses have been separated to avoid confusion for users.",
          newRoute: false
        }
      ]
    },
    {
      date: new Date('2026-03-05'),
      updates: [
        {
          route: '/freightmancerlvl99',
          description: 'Lading status defaults to Unassigned.',
          newRoute: false
        },
        {
          route: '/work_order_details',
          description: '"Add Service" pop-up in the financials tab is now easier to use. When switching a consignee or shipper, full address now shows in the dropdown list',
          newRoute: false
        }
      ]
    },
    {
      date: new Date('2026-03-04'),
      updates: [
        {
          route: '/users',
          description: 'Users with access to the user management page can now disable users using the trash icons on the right side of the grid.',
          newRoute: false
        },
        {
          route: '/site_updates',
          description: 'Check this page for a log of recent AMS changes.',
          newRoute: true
        },
        {
          route: '/inventory_management',
          description:  "Fixed an issue where certain model numbers weren't shown in the main grid view.",
          newRoute: false
        },
        {
          route: '/orders',
          description: 'Tweaked row details view to show freight information and lading financials summary.',
          newRoute: false
        },
        {
          route: '/carrier_orders',
          description: 'CRST can now access and edit data relevant to their orders.',
          newRoute: true
        }
      ]
    }
  ]

  constructor(private http: HttpClient){}

  ngOnInit(){
    this.http.get<{code: number, result: boolean}>(this.internalUserCheckURL).subscribe(
      res => {
        console.log(res)
        if (res.code === 200 && res.result) this.permissionToLoad = true;
      }
    )
  }
}

interface SiteUpdateSection {
  date: Date;
  updates: UpdateItem[];
}

interface UpdateItem {
  route: string;
  description: string;
  newRoute: boolean;
}
